import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import enLogin from "./locales/en/login.json";
import enLegal from "./locales/en/legal.json";
import enCustomer from "./locales/en/customer.json";
import enContractor from "./locales/en/contractor.json";

import zhCommon from "./locales/zh-CN/common.json";
import zhLogin from "./locales/zh-CN/login.json";
import zhLegal from "./locales/zh-CN/legal.json";
import zhCustomer from "./locales/zh-CN/customer.json";
import zhContractor from "./locales/zh-CN/contractor.json";

/**
 * OrkaiFlow i18n config
 * --------------------
 * Namespaces are grouped by surface (login, legal, customer, contractor)
 * plus a shared `common` namespace for buttons/labels reused across pages.
 * English is the source of truth — if a Chinese key is missing, i18next
 * falls back to English so the app never renders a raw key.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        login: enLogin,
        legal: enLegal,
        customer: enCustomer,
        contractor: enContractor,
      },
      "zh-CN": {
        common: zhCommon,
        login: zhLogin,
        legal: zhLegal,
        customer: zhCustomer,
        contractor: zhContractor,
      },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "zh-CN"],
    ns: ["common", "login", "legal", "customer", "contractor"],
    defaultNS: "common",
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      // Persist choice in localStorage so it survives reloads and sync
      // across tabs.
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "orkaiflow.lang",
      caches: ["localStorage"],
    },
    // React 18/19 concurrent-mode safe
    react: { useSuspense: false },
  });

export default i18n;
